import type {SVGProps} from 'react'
const SvgPaper = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="#1D9089"
      fillRule="evenodd"
      d="M3 2a1 1 0 0 1 1-1h6a1 1 0 0 1 .707.293l2 2A1 1 0 0 1 13 4v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm1 0v12h8V4l-2-2z"
      clipRule="evenodd"
    />
    <path
      fill="#1D9089"
      fillRule="evenodd"
      d="M9.617 1.076a1 1 0 0 1 1.09.217l2 2A1 1 0 0 1 12 5h-2a1 1 0 0 1-1-1V2a1 1 0 0 1 .617-.924M10 2v2h2z"
      clipRule="evenodd"
    />
    <path
      fill="#1D9089"
      d="M5 6.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5M5 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5M5 10.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5M5 12.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
    />
  </svg>
)
export default SvgPaper
